import { useEffect, useState } from "react";
import { getProductSerialsPartner } from "../../functions";
import { statusFlow } from "../../../utils/allProductStatus";
import { getScoreTitle } from "../../../utils/gradingTypes";
import Loading from "../../../atoms/loading";
import Serial from "../../../serials/registerSerials/serial";
import CopyIcon from "../../../../img/copyIcon";
import { getVisibleGradeFields, renderApplicableGradeValue } from "../../../utils/serialGradeFields";


const PartnerProductSerials = ({ user, productData, setProductData }) => {

    const [loading, setLoading] = useState(false);
    const [productSerials, setProductSerials] = useState([]);

    useEffect(() => {
        doGetProductSerials();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        setProductData(pd => { return { ...pd, serials: productSerials } });
        // eslint-disable-next-line
    }, [productSerials]);

    const doGetProductSerials = async () => {
        if (!productData) {
            return null;
        }
        setLoading(true);
        const data = await getProductSerialsPartner(user?.token, productData?._id);
        if (!data?.type === "success") {
            setLoading(false);
            return null;
        }

        setProductSerials(data?.data);
        setLoading(false);
    }

    const getStatusIndex = () => {
        if (!statusFlow?.[productData?.delivery]) {
            return false;
        }
        const gradedIndex = Object?.keys(statusFlow?.[productData?.delivery])?.indexOf("GRADED");
        const currentIndex = Object?.keys(statusFlow?.[productData?.delivery])?.indexOf(productData?.status);
        return currentIndex >= gradedIndex;
    }

    const copyGradesToClipboard = () => {
        const gradesString = productSerials?.map(ps => {
            const visibleGrades = getVisibleGradeFields(ps, productData);
            const gradeLines = [
                ...visibleGrades.subgrades.map(field => `${field.label}: ${renderApplicableGradeValue(field.value)}`),
                ...(visibleGrades.autographNote ? [`${visibleGrades.autographNote.label}: ${renderApplicableGradeValue(visibleGrades.autographNote.value)}`] : []),
                ...(visibleGrades.generalScore ? [`Nota Final: ${renderApplicableGradeValue(visibleGrades.generalScore.value)} (${getScoreTitle(visibleGrades.generalScore.value) || "-"})`] : [])
            ];
            return `
            ${ps?.serialNumber}\n
            ${ps?.gradableModel?.name} ${ps?.gradableModel?.numbering}
            ${gradeLines.join("\n            ")}\n
            --- 
            `
        })?.join("");
        navigator.clipboard.writeText(gradesString);
    }


    if (loading) {
        return (
            <div className="m-4 border border-[#666] p-2">
                <div className="w-fit m-auto">
                    <Loading />
                </div>
            </div>
        )
    }
    return (
        <div className="m-4 border border-[#666] p-2 bg-monao relative">
            {
                getStatusIndex() ?
                    <div onClick={copyGradesToClipboard} className="absolute top-2 left-2 cursor-pointer" title="Copiar notas"><CopyIcon fill="#d59106" /></div>
                    : null
            }
            <h2 className="text-center text-lg mb-0">Seriais do pedido</h2>
            <h3 className="mt-0 mb-4 text-center text-sm">Cadastrados: {productSerials?.length || 0}/{productData?.numberOfCards}</h3>
            <div className="max-h-[400px] overflow-y-scroll">
                {
                    productSerials?.map((s, i) => (
                        <Serial user={user} serial={s} product={productData} index={i} key={i} refresh={doGetProductSerials} setProductSerials={setProductSerials} />
                    ))
                }
            </div>
        </div>
    )
}

export default PartnerProductSerials;
